<template>
  <div class="green-note-container d-flex align-items-start flex-column mb-5 mt-5" :class="isPhone ? 'px-3' : 'px-5'">
    <h2 :class="isPhone ? 'merriweather-reg-20 mb-1' : 'merriweather-reg-24'">Leur engagement environnemental</h2>
    <h3 :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-20'">L’éco-responsabilité au cœur des engagements de chaque hôte.</h3>
    <div class="d-flex justify-content-between align-items-center mb-2 w-100" :class="isPhone ? '' : 'mt-3'" >
      <div class="d-flex">
        <h4 class="text-uppercase la-green-note" :class="isPhone ? 'raleway-semi-p15 mt-1' : 'raleway-semi-p20'">La Green Note</h4>
        <img src="../../images/greenFull.svg" :class="isPhone ? 'ml-1' : 'ml-3'" v-set-alt style="width: 31px;height: 31px;" />
      </div>
      <a class="text-green text-underline" :class="isPhone ? 'raleway-semi-p15 mb-3' : 'raleway-semi-p13'" href="/green-note-engagement-environnemental" target="_blank">Qu’est-ce que la Green Note ?</a>
    </div>
    <p class="raleway-reg-p15">La Green Note minimale pour intégrer notre sélection est de 5/10, un seuil qui reflète déjà des initiatives concrètes en matière d’engagement responsable.</p>

    <div class="green-note-content d-flex mt-3 w-100" :class="isPhone ? 'flex-column align-items-center' : 'flex-row align-items-start'">
      <div class="d-flex green_score_cont" :class="isPhone ? 'mt-2' : 'mt-5 mb-3'" data-aos="fade-left" data-aos-duration="900">
        <img v-if="this.lodging.score" :src="greenNotePicto(this.lodging.score.toFixed())" style="width: 23px;height: 33px;" :alt="this.lodging.score.toFixed()" />
        <div class="content d-flex align-items-center ml-2" v-if="this.lodging.score">
          <div class="note d-flex align-items-end ml-2">
            <p class="raleway-medi-p20 mb-0">{{ this.lodging.score.toFixed() }}/</p>
            <p class="raleway-medi-p15 mb-0 mr-2">10</p>
            <p class="raleway-bold-p15 mb-0 text-uppercase">
              {{ this.lodging.green_note_mention }}
            </p>
          </div>
        </div>
        <div class="content d-flex flex-column" v-else>
          <div class="note d-flex">
            <p class="raleway-medi-p20 mb-0">_/</p>
            <p class="raleway-medi-p15 mb-0 mr-2">10</p>
            <p class="raleway-bold-p15 mb-0"></p>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column w-100" data-aos="fade-right" data-aos-duration="900" :class="isPhone ? '' : 'ml-5'">
        <div class="slider-container w-100 pb-5">
          <div class="slider-tooltip-top" :style="topTooltipStyle">
            <div class="tooltip-arrow-top">
              <span class="text-green" :class="isPhone ? 'raleway-semi-p11' : 'raleway-semi-p13'">CET HÔTE</span>
            </div>
          </div>
          <div class="slider-bar mt-5 mb-2">
            <span class="ranking-number" :class="isPhone ? 'raleway-medi-p9' : 'raleway-medi-p20'">5</span>
            <span class="ranking-number" :class="isPhone ? 'raleway-medi-p9' : 'raleway-medi-p20'">6</span>
            <span class="ranking-number" :class="isPhone ? 'raleway-medi-p9' : 'raleway-medi-p20'">7</span>
            <span class="ranking-number" :class="isPhone ? 'raleway-medi-p9' : 'raleway-medi-p20'">8</span>
            <span class="ranking-number" :class="isPhone ? 'raleway-medi-p9' : 'raleway-medi-p20'">9</span>
            <span class="ranking-number" :class="isPhone ? 'raleway-medi-p9' : 'raleway-medi-p20'">10</span>
          </div>
          <div class="slider-tooltip-bottom" :style="bottomTooltipStyle">
            <div class="tooltip-arrow-bottom">
              <span :class="isPhone ? 'raleway-semi-p11' : 'raleway-semi-p13'">MOYENNE DES HÔTES HORTENSE</span>
            </div>
          </div>
        </div>
        <div class="note-buttons-wrapper mt-3">
          <div class="note-buttons-container">
            <div class="note-button-1">
              <p class="text-center mb-0" :class="isPhone ? 'raleway-semi-p7' : 'raleway-semi-p13'">DE 5 À 6<br />MENTION CONVENABLE</p>
            </div>
            <div class="note-button-2">
              <p class="text-center mb-0" :class="isPhone ? 'raleway-semi-p7' : 'raleway-semi-p13'">DE 6 À 7<br />MENTION HONORABLE</p>
            </div>
            <div class="note-button-3">
              <p class="text-center mb-0" :class="isPhone ? 'raleway-semi-p7' : 'raleway-semi-p13'">DE 7 À 8<br />MENTION REMARQUABLE</p>
            </div>
            <div class="note-button-4">
              <p class="text-center mb-0" :class="isPhone ? 'raleway-semi-p7' : 'raleway-semi-p13'">DE 8 À 10<br />MENTION EXEMPLAIRE</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "LodgingshowGreenNote",
  props: {
    lodging: {
      type: Object,
      required: true,
    },
    isPhone: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    score() {
      return this.lodging?.score || 0;
    },
    currentScore() {
      const score = this.lodging?.score || 0;
      return Math.max(5, Math.min(10, score));
    },
    topTooltipStyle() {
      const score = this.currentScore;
      const leftMargins = {
        5: '+ 1.5rem',
        6: '+ 1rem',
        7: '',
        8: '- 0.3rem',
        9: '- 1.5rem',
        10: '- 2rem',
      };
      const roundedScore = score.toFixed();
      const index = roundedScore - 5; // 0 for score 5, 5 for score 10
      const totalItems = 6;
      // With space-around: position = (index + 0.5) / totalItems * 100%
      const position = ((index + 0.5) / totalItems) * 100;
      const adjustPosition = leftMargins[roundedScore];
      return {
        left: `calc(${position}% ${adjustPosition})`,
      };
    },
    bottomTooltipStyle() {
      const score = 7;
      const index = score - 5; // index 2 for score 7
      const totalItems = 6;
      const position = ((index + 0.5) / totalItems) * 100;
      return {
        left: `${position}%`,
      };
    },
  },
  methods: {
    greenNotePicto(score) {
      if (score === `${score}`) {
        return require(`../../images/greennote ${score}.svg`);
      } else {
        return require("../../images/blanc.png");
      }
    },
  },
};
</script>
<style scoped lang="scss">
.green-note-container {
  .green_score_cont {
    height: 73px;
    border: 1px solid #CFE5DC;
    border-radius: 20px;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    @media screen and (max-width: 480px) {
      height: 51px;
      padding: 15px;
      border-radius: 15px;
    }
  }

  .slider-container {
    position: relative;
    margin-top: 2rem;
    padding: 0 1rem;

    .slider-tooltip-top {
      position: absolute;
      top: 0;
      height: 50px;
      margin-bottom: 10px;
      transform: translateX(-50%);

      .tooltip-arrow-top {
        display: flex;
        flex-direction: column;
        align-items: center;

        span {
          position: relative;
          padding: 0.5rem 1rem;
          border: 1px solid #2C5E4B;
          border-radius: 15px;
          white-space: nowrap;
          background: white;
        }

        span::after {
          content: "";
          position: absolute;
          bottom: -6px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-top: 6px solid #2C5E4B;
        }
      }
    }

    .slider-bar {
      position: relative;
      height: 33px;
      background: transparent linear-gradient(90deg, #7DCEAE 0%, #65B194 36%, #4E8E75 69%, #3B6151 100%) 0% 0% no-repeat padding-box;
      border-radius: 15px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 0 1rem;

      @media screen and (max-width: 480px) {
        height: 17px;
      }

      .ranking-number {
        color: white;
        font-weight: 500;
        z-index: 1;
      }
    }

    .slider-tooltip-bottom {
      position: absolute;
      bottom: 0;
      height: 50px;
      margin-top: 10px;
      transform: translateX(-50%);

      .tooltip-arrow-bottom {
        display: flex;
        flex-direction: column;
        align-items: center;

        span {
          position: relative;
          padding: 0.5rem 1rem;
          border: 1px solid #2C5E4B;
          border-radius: 15px;
          white-space: nowrap;
          background-color: #2C5E4B;
          color: white;
        }

        span::before {
          content: "";
          position: absolute;
          top: -6px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-bottom: 6px solid #2C5E4B;
        }
      }
    }

    @media screen and (max-width: 480px) {
      padding: 0 0.5rem;

      .slider-bar {
        padding: 0 0.5rem;
      }

      .slider-tooltip-top,
      .slider-tooltip-bottom {
        .tooltip-arrow-top span,
        .tooltip-arrow-bottom span {
          padding: 0.3rem 0.6rem;
        }
      }
    }
  }
}

.text-green {
  color: #2C5E4B;
}

.note-buttons-wrapper {
  padding: 0 1rem;

  @media screen and (max-width: 480px) {
    padding: 0 0.5rem;
  }
}

.note-buttons-container {
  display: grid;
  grid-template-columns: 1.8fr 1.2fr 1.2fr 3fr;
  gap: 4px;
  width: 100%;
  @media screen and (max-width: 480px) {
    gap: 5px;
  }
}

.note-button-1 {
  background-color: #DBE8CC;
  border-radius: 15px;
  padding: 15px 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 480px) {
    padding: 7px 4px 5px 4px;
    height: 40px;
  }
}

.note-button-2 {
  background-color: #B5DABB;
  border-radius: 15px;
  padding: 15px 8px;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 480px) {
    padding: 7px 4px 5px 4px;
    height: 40px;
  }
}

.note-button-3 {
  background-color: #7DCEAE;
  border-radius: 15px;
  padding: 15px 8px;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 480px) {
    padding: 7px 4px 5px 4px;
    height: 40px;
  }
}

.note-button-4 {
  background-color: #4E8E74;
  border-radius: 15px;
  padding: 15px 8px;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 480px) {
    padding: 7px 4px 5px 4px;
    height: 40px;
  }
}
</style>